import { AssetContractTypeContract } from 'ApiClient/asset/types/AssetContractTypeContract'
import { AssetTypeContract } from 'ApiClient/asset/types/AssetTypeContract'
import { ThumbnailWidthSizeContract } from 'ApiClient/asset/types/ThumbnailWidthSizeContract'

import { servicesAsync } from 'Common/environment/environment'
import { fetchGet } from 'Common/utils/query/request'

const thumbnailWidthSizesUrl = servicesAsync.assets('/v1/thumbnailWidthSizes')
const assetTypesUrl = servicesAsync.assets('/v1/assetTypes')
const assetContractTypesUrl = servicesAsync.assets('/v1/assetContractTypes')

export const thumbnailWidthSizesGet = async () => {
    const result = await fetchGet(await thumbnailWidthSizesUrl)
    return result as ThumbnailWidthSizeContract[]
}

export const assetTypesGet = async () => {
    const result = await fetchGet(await assetTypesUrl)
    return result as AssetTypeContract[]
}

export const assetContractTypesGet = async () => {
    const result = await fetchGet(await assetContractTypesUrl)
    return (result ?? []) as AssetContractTypeContract[]
}
